import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Form, Button } from 'react-bootstrap';
import { Multiselect } from 'multiselect-react-dropdown';
import { technologyOptions } from '../../../configs/dropdownOptions';
import CyberSecurity from '../../../apis/cyberSecurityData';
import _ from 'lodash';

const TechnologySelect = ({ onTechValuesChange, technology }) => {
  //redux store state
  const accessToken = useSelector(state => state.accessToken);
  //comp state
  const [options, setOptions] = useState([]);
  const [selectedTech, setSelectedTech] = useState(technology || '');
  const [newTech, setNewTech] = useState('');

  const getOptions = async () => {
    const response = await CyberSecurity.get('/techoptions', {
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    })

    const combinedOptions = _.union(technologyOptions(), response.data)
    setOptions(combinedOptions);
  }

  useEffect(() => {
    getOptions();
  }, [])

  const onSelect = (values) => {
    setSelectedTech(values)
    onTechValuesChange(values)
  }

  const onRemove = (values) => {
    setSelectedTech(values)
    onTechValuesChange(values)
  }

  const onAddTechnologyClick = () => {
    if (newTech) {
      setOptions([...options, newTech]);
      setSelectedTech([...selectedTech, newTech])
      onTechValuesChange([...selectedTech, newTech])
      setNewTech('')
    }
  }

  const darkMode = useSelector(state => state.darkMode)

  return (
    <div className="my-2">
      <Multiselect
        options={options} // Options to display in the dropdown
        isObject={false} //add if using plain array
        selectedValues={selectedTech} // Preselected value to persist in dropdown
        onSelect={onSelect} // Function will trigger on select event
        onRemove={onRemove} // Function will trigger on remove event
        // displayValue="Choose Technology" // Property name to display in the dropdown options (if using object not plain array)
        closeOnSelect
        placeholder="Choose Technology"
        closeIcon="cancel"
        style={{
          multiselectContainer: { // To change css for multiselect (Width,height,etc..)
            background: darkMode ? '#25272D' : 'transparent',
            marginLeft: '8px',
            borderRadius: '5px',
            // width: '500px'
          },
          optionContainer: { // To change css for option container
            display: 'flex',
            flexDirection: 'column',
            background: darkMode ? '#25272D' : 'transparent',
          },
          chips: { // To change css chips(Selected options)
            background: 'grey',
            fontSize: '12px',
          }
        }}
      />

      <div className="d-flex">
        <Form.Control className="small-input even-width" type="text" placeholder="Add new technology" size="sm" value={newTech} onChange={e => setNewTech(e.target.value)} onKeyPress={e => { if (e.key === 'Enter') onAddTechnologyClick() }} />
        <Button className="text-sm" variant="link" size="sm" onClick={onAddTechnologyClick}>Add New Tech</Button>
      </div>
    </div>
  )
}

export default TechnologySelect
